import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { Table } from "primeng/table";
import { ConversaoLibraConverte } from "../../../shared/conversao-libra/conversao-libra-converte";
import { ExportExcelService } from "../../../shared/excel-service/export-excel.service";
import { FiltroService } from "../../../shared/filtro/filtro.service";
import { VendasPendentesService } from "./vendas-pendentes.service";
import { VendasPendentesFiltroService } from "./vendas-pendentes-filtro.service";
import { FiltroDealers } from "./filtro-dealer";
import { Location } from "@angular/common";

@Component({
  selector: "app-vendas-pendentes-pecas",
  templateUrl: "./vendas-pendentes-pecas.component.html",
  styleUrls: ["./vendas-pendentes-pecas.component.scss"],
})
export class VendasPendentesPecasComponent implements OnInit {
  @Input() filtros: any;
  form: FormGroup;
  subscription: any;
  data: Date;
  selecionado: object;
  selecionados = [];
  tipo = [];
  vendaDireta = [];
  marcas = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  dealersDadosExcel: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  valorDataInicialRecebeParametro: any;
  valorDataFinalRecebeParametro: any;
  chassi: any;
  totalVendaPendente:any;

  situacaoValue: number;

  maxDate: Date = new Date();

  filtrosDealers: FiltroDealers;

  private isFiltering: boolean = false;
  validaButtonRedireciona: boolean = false;
  valorChassiRecebe: any;

  @ViewChild("dt") dt: Table;

  dadosTranslate = {
    codDealer: "pca.vendasPendentesPecas.codDealer",
    codigoItem: "pca.vendasPendentesPecas.codigoItem",
    dataPendente: "pca.vendasPendentesPecas.dataPendente",
    descModelo: "pca.vendasPendentesPecas.descModelo",
    descricaoItem: "pca.vendasPendentesPecas.descricaoItem",
    descricaoOsFabrica: "pca.vendasPendentesPecas.descricaoOsFabrica",
    email: "pca.vendasPendentesPecas.email",
    fone: "pca.vendasPendentesPecas.fone",
    nome: "pca.vendasPendentesPecas.nome",
    nomeDealer: "pca.vendasPendentesPecas.nomeDealer",
    numeroChassi: "pca.vendasPendentesPecas.numeroChassi",
    numeroOs: "pca.vendasPendentesPecas.numeroOs",
    numeroPedidoDealer: "pca.vendasPendentesPecas.numeroPedidoDealer",
    numeroPedidoFabrica: "pca.vendasPendentesPecas.numeroPedidoFabrica",
    precoTotal: "pca.vendasPendentesPecas.precoTotal",
    precoUnitario: "pca.vendasPendentesPecas.precoUnitario",
    prefixo: "pca.vendasPendentesPecas.prefixo",
    quantidade: "pca.vendasPendentesPecas.quantidade",
    quantidadeDiasOficina: "pca.vendasPendentesPecas.quantidadeDiasOficina",
    nomeConsultor: "pca.vendasPendentesPecas.nomeConsultor",
    quantidadeTotalRegistros:
      "pca.vendasPendentesPecas.quantidadeTotalRegistros",
    tipoOsFabrica: "pca.vendasPendentesPecas.tipoOsFabrica",
  };

  constructor(
    private service: VendasPendentesService,
    private location: Location,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: VendasPendentesFiltroService,
    private vendasPendentesPecas: FiltroService,
    private exportExcelService: ExportExcelService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private date: DatePipe,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.filtros = {};
    this.nomeModulo = "vendas-pendentes-pecas";
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format("DD-MM-YYYY")],
      data_final: [moment(this.dataFinal).format("DD-MM-YYYY")],
      dealers: [""],
      numeroOs: [""],
      chassi: [""],
      codItem: [""],
      original: [""]
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const temParametros =
        (params.chassi && params.chassi !== "") ||
        (params.cpf && params.cpf !== "");

      if (temParametros) {
        const vdataInicial = params.dataInicial;
        const vdataFinal = params.dataFinal;
        this.chassi = params.chassi;

        if (moment(vdataInicial, "DD/MM/YYYY", true).isValid()) {
          this.dataInicial = moment(vdataInicial, "DD/MM/YYYY").toDate();
        } else {
          console.error("Data inicial inválida:", vdataInicial);
          this.dataInicial = new Date();
        }

        if (moment(vdataFinal, "DD/MM/YYYY", true).isValid()) {
          this.dataFinal = moment(vdataFinal, "DD/MM/YYYY").toDate();
        } else {
          console.error("Data final inválida:", vdataFinal);
          this.dataFinal = new Date();
        }

        this.f.data_inicial.setValue(
          moment(this.dataInicial).format("DD/MM/YYYY")
        );
        this.f.data_final.setValue(moment(this.dataFinal).format("DD/MM/YYYY"));
        this.f.chassi.setValue(this.chassi);

        this.getAll();
        this.validaButtonRedireciona = true;
      } else {
        this.validaButtonRedireciona = false;
      }
    });

    this.changeLanguageValue();
    this.preencherMarcas();

    this.loading = true;

    this.cols = [
      {
        field: "codDealer",
        header: "pca.vendasPendentesPecas.codDealer",
        headerBr: "Cód. Dealer",
        headerGb: "Dealer Code",
        width: "100px",
      },
      {
        field: "nomeDealer",
        header: "pca.vendasPendentesPecas.nomeDealer",
        headerBr: "Dealer",
        headerGb: "Dealer Name",
        width: "250px",
      },
      {
        field: "numeroOs",
        header: "pca.vendasPendentesPecas.numeroOs",
        headerBr: "Número OS",
        headerGb: "OS Number",
        width: "120px",
      },
      {
        field: "numeroPedidoFabrica",
        header: "pca.vendasPendentesPecas.numeroPedidoFabrica",
        headerBr: "Número Pedido Fábrica",
        headerGb: "Factory Order Number",
        width: "200px",
      },
      {
        field: "numeroPedidoDealer",
        header: "pca.vendasPendentesPecas.numeroPedidoDealer",
        headerBr: "Número Pedido Dealer",
        headerGb: "Dealer Order Number",
        width: "200px",
      },
      {
        field: "codigoItem",
        header: "pca.vendasPendentesPecas.codigoItem",
        headerBr: "Código Item",
        headerGb: "Item Code",
        width: "120px",
      },
      {
        field: "descricaoItem",
        header: "pca.vendasPendentesPecas.descricaoItem",
        headerBr: "Descrição Item",
        headerGb: "Item Description",
        width: "300px",
      },
      {
        field: "quantidade",
        header: "pca.vendasPendentesPecas.quantidade",
        headerBr: "Quantidade",
        headerGb: "Quantity",
        width: "100px",
      },
      {
        field: "precoUnitario",
        header: "pca.vendasPendentesPecas.precoUnitario",
        headerBr: "Preço Unitário",
        headerGb: "Unit Price",
        width: "120px",
      },
      {
        field: "precoTotal",
        header: "pca.vendasPendentesPecas.precoTotal",
        headerBr: "Preço Total",
        headerGb: "Total Price",
        width: "120px",
      },
      {
        field: "dataPendente",
        header: "pca.vendasPendentesPecas.dataPendente",
        headerBr: "Data Pendente",
        headerGb: "Pending Date",
        width: "120px",
        type: this.data,
        arg1: `dd/MM/yyyy`,
      },
      {
        field: "tipoOsFabrica",
        header: "pca.vendasPendentesPecas.tipoOsFabrica",
        headerBr: "Tipo OS Fábrica",
        headerGb: "Factory OS Type",
        width: "130px",
      },
      {
        field: "descricaoOsFabrica",
        header: "pca.vendasPendentesPecas.descricaoOsFabrica",
        headerBr: "Descrição OS Fábrica",
        headerGb: "Factory OS Description",
        width: "200px",
      },
      {
        field: "descModelo",
        header: "pca.vendasPendentesPecas.descModelo",
        headerBr: "Desc. Modelo",
        headerGb: "Model Description",
        width: "200px",
      },
      {
        field: "numeroChassi",
        header: "pca.vendasPendentesPecas.numeroChassi",
        headerBr: "Número Chassi",
        headerGb: "Chassis Number",
        width: "150px",
      },
      {
        field: "quantidadeDiasOficina",
        header: "pca.vendasPendentesPecas.quantidadeDiasOficina",
        headerBr: "Qtd. Dias Oficina",
        headerGb: "Workshop Days Qty",
        width: "130px",
      },
      {
        field: "nome",
        header: "pca.vendasPendentesPecas.nome",
        headerBr: "Nome",
        headerGb: "Name",
        width: "200px",
      },
      {
        field: "prefixo",
        header: "pca.vendasPendentesPecas.prefixo",
        headerBr: "Prefixo",
        headerGb: "Prefix",
        width: "100px",
      },
      {
        field: "fone",
        header: "pca.vendasPendentesPecas.fone",
        headerBr: "Telefone",
        headerGb: "Phone",
        width: "120px",
      },
      {
        field: "email",
        header: "pca.vendasPendentesPecas.email",
        headerBr: "Email",
        headerGb: "Email",
        width: "250px",
      },
      {
        field: "nomeConsultor",
        header: "pca.vendasPendentesPecas.nomeConsultor",
        headerBr: "Consultor",
        headerGb: "Consultant",
        width: "200px",
      },
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter((col) => val.includes(col));
  }

  get f() {
    return this.form.controls;
  }

  private preencherMarcas() {
    this.vendasPendentesPecas.buscar("marca").then((r) => {
      this.marcas = r.filtros;
    });
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.numeroOs.value, this.f.chassi.value, this.f.codItem.value, this.f.original.value).subscribe((dados) => {

        this.dealersDados = JSON.parse(JSON.stringify(dados.dados));
        this.dealersDadosExcel = JSON.parse(JSON.stringify(dados.dados));

        const converterEFormatar = (valor: number) => {
          const convertido = this.conversaoLibraConverte.conversaoLibra(valor, null, null);
          if (this.translate.currentLang == "br") {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(convertido);
          } else {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(convertido);
          }
        };

        this.totalVendaPendente = converterEFormatar(dados.totalVendaPendente);

        this.dealersDados.forEach((element) => {
          element.precoTotal = converterEFormatar(element.precoTotal);
          element.precoUnitario = converterEFormatar(element.precoUnitario);
        });
        this.loading = false;
      });
  }

  private tratarData() {
    const dataFim = new Date();

    let firstDay = new Date(2020, 0, 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format("DD-MM-YYYY"));
    this.f.data_final.setValue(moment(this.dataFinal).format("DD-MM-YYYY"));

    this.filtrosSelecionados();
    this.getAll();

    this.displayFiltros = false;
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map((r) => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue("");
    }
  }

  public getListagemComFiltros(): boolean {
    return (
      this.dataInicial ||
      this.dataFinal ||
      this.f.numeroOs.value ||
      this.f.chassi.value ||
      this.f.codItem.value ||
      this.f.original.value
    );
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { chave: "dealers", valor: [] };
      this.filtrosDealers.selecionados().forEach((element) => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.numeroOs.setValue("");
    this.f.chassi.setValue("");
    this.f.codItem.setValue("");
    this.f.original.setValue("");
  }

  public limpaDataInicial() {
    this.dataInicial = new Date(
      2020,
      0,
      1
    );
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(
      dataFim.getFullYear(),
      dataFim.getMonth(),
      dataFim.getDate()
    );
  }

  protected getTranslate(value) {
    if (value.status == "Vendido") {
      return this.translate.currentLang == "br"
        ? (value.status = "Vendido")
        : (value.status = "Sold");
    }

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "pca.vendasPendentesPecas.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }
    if (item == "pca.vendasPendentesPecas.codigoItem") {
      return this.translate.currentLang == "br" ? "Código Item" : "Item Code";
    }
    if (item == "pca.vendasPendentesPecas.dataPendente") {
      return this.translate.currentLang == "br"
        ? "Data Pendente"
        : "Pending Date";
    }
    if (item == "pca.vendasPendentesPecas.descModelo") {
      return this.translate.currentLang == "br"
        ? "Desc. Modelo"
        : "Model Description";
    }
    if (item == "pca.vendasPendentesPecas.descricaoItem") {
      return this.translate.currentLang == "br"
        ? "Descrição Item"
        : "Item Description";
    }
    if (item == "pca.vendasPendentesPecas.descricaoOsFabrica") {
      return this.translate.currentLang == "br"
        ? "Descrição OS Fábrica"
        : "Factory OS Description";
    }
    if (item == "pca.vendasPendentesPecas.email") {
      return this.translate.currentLang == "br" ? "Email" : "Email";
    }
    if (item == "pca.vendasPendentesPecas.fone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Phone";
    }
    if (item == "pca.vendasPendentesPecas.nome") {
      return this.translate.currentLang == "br" ? "Nome" : "Name";
    }
    if (item == "pca.vendasPendentesPecas.nomeDealer") {
      return this.translate.currentLang == "br" ? "Dealer" : "Dealer Name";
    }
    if (item == "pca.vendasPendentesPecas.numeroChassi") {
      return this.translate.currentLang == "br"
        ? "Número Chassi"
        : "Chassis Number";
    }
    if (item == "pca.vendasPendentesPecas.numeroOs") {
      return this.translate.currentLang == "br" ? "Número OS" : "OS Number";
    }
    if (item == "pca.vendasPendentesPecas.numeroPedidoDealer") {
      return this.translate.currentLang == "br"
        ? "Número Pedido Dealer"
        : "Dealer Order Number";
    }
    if (item == "pca.vendasPendentesPecas.numeroPedidoFabrica") {
      return this.translate.currentLang == "br"
        ? "Número Pedido Fábrica"
        : "Factory Order Number";
    }
    if (item == "pca.vendasPendentesPecas.precoTotal") {
      return this.translate.currentLang == "br" ? "Preço Total" : "Total Price";
    }
    if (item == "pca.vendasPendentesPecas.precoUnitario") {
      return this.translate.currentLang == "br"
        ? "Preço Unitário"
        : "Unit Price";
    }
    if (item == "pca.vendasPendentesPecas.prefixo") {
      return this.translate.currentLang == "br" ? "Prefixo" : "Prefix";
    }
    if (item == "pca.vendasPendentesPecas.quantidade") {
      return this.translate.currentLang == "br" ? "Quantidade" : "Quantity";
    }
    if (item == "pca.vendasPendentesPecas.quantidadeDiasOficina") {
      return this.translate.currentLang == "br"
        ? "Qtd. Dias Oficina"
        : "Workshop Days Qty";
    }
    if (item == "pca.vendasPendentesPecas.quantidadeTotalRegistros") {
      return this.translate.currentLang == "br"
        ? "Qtd. Total Registros"
        : "Total Records Qty";
    }
    if (item == "pca.vendasPendentesPecas.tipoOsFabrica") {
      return this.translate.currentLang == "br"
        ? "Tipo OS Fábrica"
        : "Factory OS Type";
    }
    if (item == "pca.vendasPendentesPecas.nomeConsultor") {
      return this.translate.currentLang == "br" 
      ? "Consultor" : "Consultant";
    }
  }

  private translateField(item) {
    if (
      item == "pca.vendasPendentesPecas.statusGrid.vendido" ||
      item == "Vendido"
    ) {
      return this.translate.currentLang == "br" ? "Vendido" : "Sold";
    }

    return item;
  }

  public detalhado(index) {
    this.numero_nfe = index.numero_nfe;
    this.serie = index.serie;
    this.id_dealer = index.id;
    this.router.navigate(["veiculo/vendido-detalhado/"], {
      queryParams: {
        numero_nfe: this.numero_nfe,
        serie: this.serie,
        dealer: this.id_dealer,
      },
    });
  }

  public exportExcel() {
    let registros = [];
    registros = this.dealersDadosExcel;

    if (registros.length > 0) {
      this.exportExcelService.nomeModulo = this.nomeModulo;
      this.exportExcelService.ExportTOExcelJSON(
        registros.map((r) => {
          let linha = {};

          this._selectedColumns.forEach((c) => {
            if (c.field != "detalhe") {
              linha[this.translateHeader(c.header)] = this.translateField(
                r[c.field]
              );
            }
          });
          return linha;
        })
      );
    }
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      }
    );
  }

}